/**
 * Copy for the brand column on the split auth pages.
 *
 * Kept here rather than inline so the four pages can't drift apart and so the
 * wording sits in one reviewable place. The plaintiff-facing lines are lifted
 * from REDESIGN.md §4.2 and §4.3, which are approved copy — the hero headline,
 * the three steps and the pills. Don't reword those without checking there.
 *
 * `headline` is JSX because <em> marks the accented phrase; it renders as a
 * paragraph, not a heading. See AuthSplitLayout.
 */

const PILLS = ['Free to apply', 'No monthly payments', 'Lose the case, owe $0'];

const LEGAL_NOTE =
  'MyCaseLoan is a technology platform, not a funding company, lender, or law ' +
  'firm, and does not provide legal advice.';

export const LOGIN_PANEL = {
  eyebrow: 'Pre-settlement funding · No credit check',
  headline: <>Money now, while your case is <em>still open</em>.</>,
  lede:
    'Apply once and verified funders compete for your case. You pick the offer ' +
    'that costs you least. If you lose, you owe nothing.',
  pills: PILLS,
  note: LEGAL_NOTE,
};

export const SIGNUP_PANEL = {
  eyebrow: 'Three steps · About five minutes',
  headline: <>Apply Today. Get offers <em>right away</em>.</>,
  steps: [
    { title: 'You apply.', body: 'About five minutes, no documents to dig up.' },
    { title: 'We reach out to your attorney.', body: 'Not you — we handle the verification.' },
    { title: 'Funders bid.', body: 'Compare the totals and pick one, or turn them all down.' },
  ],
  pills: ['Free to apply', 'No credit check', 'Lose the case, owe $0'],
  note: 'Figures and timings shown are illustrative examples only.',
};

export const FORGOT_PANEL = {
  eyebrow: 'Account access',
  headline: <>Locked out? It happens.</>,
  lede:
    "We'll email you a link that lets you set a new password. The link expires " +
    'after an hour.',
  note:
    "If you didn't request this, you can ignore the email — nothing changes " +
    'until the link is used.',
};

export const RESET_PANEL = {
  eyebrow: 'Account access',
  headline: <>One password, then straight back in.</>,
  lede:
    'Pick something you have not used elsewhere. You will use it to sign in ' +
    'from now on.',
  note: LEGAL_NOTE,
};
